import resolveEnv from '@fluentsms/utils';
import config from './configs.json';

export default config[resolveEnv()];
